export const HEADER_ROW_HEIGHT = 25;

export const TABLE_STYLE = {
  zIndex: 20,
  width: 'auto',
  height: '400px',
  fontWeight: 400,
};

export const HEADER_STYLE = {
  borderRight: '1px solid #ccc',
  bgcolor: '#92BBEA',
  color: '#fff',
  fontSize: 11,
  fontWeight: 800,
  height: HEADER_ROW_HEIGHT,
  padding: 0,
  paddingLeft: '2px',
  fontFamily: "'Segoe UI Bold', wf_segoe-ui_bold, helvetica, arial, sans-serif",
  textTransform: 'capitalize',
  whiteSpace: 'nowrap',
};

export const HEADER_ROW_STYLE = (rowIndex) => ({
  position: 'sticky',
  top: `${rowIndex * HEADER_ROW_HEIGHT}px`,
  fontFamily: "'Segoe UI Bold', wf_segoe-ui_bold, helvetica, arial, sans-serif",
  zIndex: 10,
});

export const ROW_STYLE = {
  borderRight: '1px solid grey',
  borderBottom: 'none',
  paddingY: 0.5,
  paddingX: 0.8,
  fontSize: 11,
  fontFamily: "'Segoe UI', wf_segoe-ui_normal, helvetica, arial, sans-serif",
  fontWeight: 400,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const TOTAL_CELL_STYLE = {
  borderRight: '1px solid grey',
  borderBottom: 'none',
  fontWeight: 600,
  fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif black',
  paddingY: 0.95,
  paddingX: 0,
  paddingRight: 1,
  fontSize: 11,
};

export const TOTAL_ROW_STYLE = {
  position: 'sticky',
  bottom: 0,
};

export const PRIMARY_ROW_COLOR = '#ffffff';
export const SECONDARY_ROW_COLOR = '#EEEDED';

export const PRIMARY_TEXT_COLOR = '#000000';
export const SECONDARY_TEXT_COLOR = '#d43754';

export const BACKGROUND_STYLE = {
  bgcolor: '#ffffff',
  padding: 1,
  borderRadius: 3,
};
export const EXPORT_BUTTON_STYLE = { alignSelf: 'flex-start', borderRadius: 0, color: 'black' };
export const HEADER_CONTAINER_STYLE = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
};

// Excel Export theme
export const EXCEL_COLORS = {
  HEADER_BG: '92BBEA',
  HEADER_TEXT: 'FFFFFF',
  BORDER: '000000',
  NEGATIVE_DATA: 'FF0000',
  ROW_BG: 'E0DEDE',
};
//
export const BORDER_PRIMITIVE = {
  style: 'thin',
  color: { rgb: EXCEL_COLORS.BORDER },
};
export const BORDERS = {
  TOP_RIGHT: {
    top: BORDER_PRIMITIVE,
    right: BORDER_PRIMITIVE,
  },
  TOP_BOTTOM_RIGHT: {
    top: BORDER_PRIMITIVE,
    bottom: BORDER_PRIMITIVE,
    right: BORDER_PRIMITIVE,
  },
  TOP: {
    top: BORDER_PRIMITIVE,
  },
};

export const SORT_STYLE = {
  color: '#fff',
  '&:hover': { color: '#fff' },
  '&.Mui-active': { color: '#fff !important' },
  '& .MuiTableSortLabel-icon': { color: '#fff !important', margin: 0 },
  '& .MuiTableSortLabel-iconDirectionAsc': { color: '#fff !important' },
  '& .MuiTableSortLabel-iconDirectionDesc': { color: '#fff !important' },
};

export const NO_RESULT_STYLE = { border: 0, pt: 20, fontWeight: 300 };
export const LOADING_STYLE = { position: 'absolute', left: 0, right: 0, border: 0, zIndex: 1000 };

export const EXPAND_BUTTON_STYLE = { padding: 0 };
export const BUTTON_ICON_STYLE = { fontSize: 10, color: '#757876' };
export const EXPAND_BUTTON_BOX_STYLE = {
  border: '1px solid #757876',
  padding: 0,
  display: 'flex',
  borderRadius: '2px',
  justifyContent: 'center',
  width: 10,
  height: 10,
  alignItems: 'center',
  mr: 1.4,
  ml: 1,
};
